import validate from './form-validation';
import { find } from './find';

function validateForm() {
    const form = document.getElementsByTagName('form')[0];

    function submitForm(e) {
        let isValid = false;
        if (form) {
            if (validate) {
                isValid = validate(form);
                if (!isValid && e) {
                    e.preventDefault();
                }
            }
        }
    }

    if (form) {
        const submitBtn = find('button[data-form-submit]', form);

        if (submitBtn) {
            submitBtn.addEventListener('click', submitForm);
        }
    }
}

module.exports = validateForm;



// WEBPACK FOOTER //
// ./src/js/contact.js